import { render, staticRenderFns } from "./RedemptionModal.vue?vue&type=template&id=63d15200&scoped=true"
import script from "./RedemptionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RedemptionModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RedemptionModal.vue?vue&type=style&index=0&id=63d15200&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d15200",
  null
  
)

export default component.exports